import { useContext, useEffect, useState } from 'react';

import * as JKYModel from '../../custom-types';
import api from '../Api';
import { authContext } from '../../contexts/AuthContext';

// Checked again each time a new song starts, which is when a count can change, and once a
// minute so plays falling out of the last week drop off without one.
const REFRESH_MS = 60 * 1000;

/**
 * The venue's song leaderboard, for the jukebox page and the TV. Empty while the owner has
 * it switched off, so nothing is asked of the server then.
 */
const useLeaderboard = (player: JKYModel.Player | undefined): JKYModel.Leader[] => {
  const context = useContext(authContext);
  const token = context.auth.token;
  const [leaders, setLeaders] = useState<JKYModel.Leader[]>([]);

  const enabled = !!(player && player.showLeaderboard);
  const code = player && player.playerIdentifier;
  const songId = player && player.nowPlayingVideo ? player.nowPlayingVideo.id : null;

  useEffect(() => {
    if (!enabled || !code) {
      setLeaders([]);
      return;
    }
    let live = true;
    const load = () =>
      api
        .players(`identifier/${code}/leaderboard`, 'GET', token, null)
        .then(response => live && setLeaders((response && response.leaders) || []))
        .catch(error => console.log('Could not load the leaderboard: ' + error.message));
    load();
    const timer = window.setInterval(load, REFRESH_MS);
    return () => {
      live = false;
      window.clearInterval(timer);
    };
  }, [enabled, code, songId, token]);

  return enabled ? leaders : [];
};

export default useLeaderboard;
